// extracted by mini-css-extract-plugin
module.exports = {"result":"urllink_result__2biEg","latestResult":"urllink_latestResult__2eWpr"};